import React from 'react';
import './EmailVerificationSuccess.css';

const EmailVerificationSuccess: React.FC = () => {
  const handleContinue = () => {
    // Redirect to login or dashboard
    window.location.href = '/';
  };

  return (
    <div className="email-verification-success-container">
      <div className="email-verification-success-card">
        <div className="success-icon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="40" cy="40" r="40" fill="#10B981"/>
            <path d="M25 40L35 50L55 30" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1 className="success-title">Email Verified Successfully!</h1>
        
        <p className="success-message">
          Great! Your email address has been verified. Your Sportagram account is now fully activated and ready to use.
        </p>
        
        <div className="success-details">
          <div className="detail-item">
            <div className="detail-icon">✓</div>
            <span>Email address confirmed</span>
          </div>
          <div className="detail-item">
            <div className="detail-icon">✓</div>
            <span>Account fully activated</span>
          </div>
          <div className="detail-item">
            <div className="detail-icon">✓</div>
            <span>Ready to explore Sportagram</span>
          </div>
        </div>
        
        <button 
          className="continue-button"
          onClick={handleContinue}
        >
          Continue to Sportagram
        </button>
        
        <div className="welcome-note">
          <p>Welcome to the Sportagram community! 🎉</p>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationSuccess;